module.exports = __webpack_public_path__ + "static/img/menu_icon7.50a05a81.png";